/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { C as index$E } from '../../index-e5fa4dec.js';
import { extend } from '../extend/index.js';
import setClipboard$1 from './browser/index.js';
import setClipboard$2 from './dingTalk/index.js';
import setClipboard$3 from './panguMiniApp/index.js';
import mini from './mini/index.js';
import '../../tslib.es6-e01eabb2.js';
import '../env/index.js';
import '../../index-f24a9ec1.js';
import '../../index-892d8eee.js';
import '../extend/register/index.js';
import '../../bridges/dd/index.js';
import '../../index-6f6b9acc.js';
import '../../_commonjsHelpers-56d33373.js';
import '../../loadscripts-cf212b8d.js';
import '../../constants-163bd007.js';
import '../../bridge-adpter-api-0316c034.js';
import '../../bridges/windvane/index.js';
import '../../bridges/nebula/index.js';
import '../../index.es-142c5680.js';
import '../../bridges/pangu-mini-app/index.js';
import '../../log-aabf3a34.js';

var apiConfig = {
    web: {
        browser: setClipboard$1,
        dingTalk: setClipboard$2,
        dingTalkPC: setClipboard$1,
    },
    mini: mini,
    panguMiniApp: setClipboard$3,
};
var extendSetClipboard = extend(apiConfig, index$E);
/**
 * 复制到剪切板。API：https://yuque.antfin.com/cn-xt/arch/lwbvd0
 * @param {!string|{text: string}} text 粘贴的文本
 * @returns {Promise<unknown>} promise调用结果
 *
 * @example
 * import { setClipboard } from '@alife/cn-uni-api';
 *
 * setClipboard('来复制我').then(() => {
 *   console.log('success');
 * }).catch((error) => {
 *   console.log(error);
 * });
 * @author 敬文
 */
var setClipboard = function (text) {
    if (typeof text === 'string') {
        return extendSetClipboard({
            text: text,
        });
    }
    return extendSetClipboard(text);
};

export { extendSetClipboard, setClipboard };
